<div>
  <br>
  <div>
    <span class="fw-extrabold fs-4">Datos del cliente</span>
  </div>
  <div class="my-3">
    <span class="fs-6 fw-regular">Ingresa los datos del cliente requeridos para este producto.</span>
  </div>
  <app-questions [showEdit]="false" (nextStep)="nextStepForm($event)"></app-questions>
</div>
